import {
  type Campaign,
  type CampaignStep,
} from 'app/src/components/NewUserOnboardingCampaign';

/**
 * Possible transitions:
 * ---------------------
 *
 * 'create-team' => 'verify-email' | 'payment' | 'ad'
 *
 * 'verify-email' => 'end'
 *
 * 'payment' => 'payment-form' | 'welcome' | 'end'
 *
 * 'ad' => 'end'
 *
 * 'payment-form' => 'welcome'
 *
 * 'welcome' => 'end'
 */
export const MoonshotSteps = {
  CREATE_TEAM: 'create-team',
  VERIFY_EMAIL: 'verify-email',
  PAYMENT: 'payment',
  /**
   * used when paying for premium upsell
   */
  PAYMENT_FORM: 'payment-form',
  /**
   * used for trello premium upsells
   */
  WELCOME: 'welcome',
  /**
   * currently, AD and PAYMENT are synonyms, both used for premium upsells
   */
  AD: 'ad',
} as const;

export const moonshotCampaign: Campaign<'moonshot', typeof MoonshotSteps> = {
  name: 'moonshot',
  steps: MoonshotSteps,
  orderedSteps: [
    MoonshotSteps.CREATE_TEAM,
    MoonshotSteps.VERIFY_EMAIL,
    MoonshotSteps.PAYMENT,
    MoonshotSteps.AD,
    MoonshotSteps.PAYMENT_FORM,
    MoonshotSteps.WELCOME,
  ],
  initialStep: MoonshotSteps.CREATE_TEAM,
  terminalSteps: [
    MoonshotSteps.WELCOME,
    MoonshotSteps.AD,
    MoonshotSteps.VERIFY_EMAIL,
  ],
};

export type MoonshotCampaign = typeof moonshotCampaign;
export type MoonshotStep = CampaignStep<MoonshotCampaign, typeof MoonshotSteps>;

export const isValidMoonshotStep = (step: string) => {
  return Object.values(MoonshotSteps).includes(step as MoonshotStep);
};
